import { Outlet, Navigate } from "react-router-dom";

const PrivateRoutes = () => {
  let auth = localStorage.getItem("emrToken") ? true : false;
  return auth ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoutes;
